/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/app.scss';

/*------------------------------------------------------------------
Add scripts to the ScriptLoader object below
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  // Add the src and a condition required to load the script
  window.ScriptLoader = ScriptLoader({
    './elements/sliders': document.querySelector('.js-slider'),
    './original/app': true,
    './original/contactForm': true,
    './original/donors': true,
    './original/ddl': true,
    './original/typed': true,
    './original/search': true,
    './elements/mobile-menu': true,
    './components/header': true,
    './components/breakpoints': true,
    './components/equalizer': true,
    './components/accordion': true,
    './elements/social': true,
    './elements/profile-form': document.querySelector('#Form_ProfileForm'),
    './elements/placeholders': document.querySelector('form'),
    './elements/macy': document.querySelector('.js-macy'),
    './elements/selects': document.querySelector('select'),
    './pages/articles': document.querySelector('.js-articles'),
    './pages/stories': document.querySelector('.DonationRecipientStoriesPage'),
    './components/random-banner': document.querySelector('.js-random-banner')
  });
});

/*------------------------------------------------------------------
Script Loader
------------------------------------------------------------------*/

function ScriptLoader(imports = {}) {
  // An array of the import object keys
  const scripts = Object.keys(imports);
  // For debugging purposes only
  const components = [];
  const load = (i = -1) => {
    // Make sure we have a script to import
    if (i >= scripts.length) {
      // Once everything has loaded, fire a 'scripts-loaded' event
      setTimeout(() => window.dispatchEvent(new Event('scripts-loaded')), 500);
      return;
    }
    ;

    // Increment the index
    i += 1;

    // If this script is not needed, continue to the next script;
    if (!imports[scripts[i]]) {
      load(i);
      return;
    }
    ;

    // Otherwise continue on to load the script
    import(`${scripts[i]}`).then(() => components.push(scripts[i])).catch(error => console.warn(scripts[i], error)).finally(() => load(i));
  };
  load();
  return components;
}
window.addEventListener('scripts-loaded', () => {
  console.log("%codnz", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
});